import { render, staticRenderFns } from "./RightColumn.vue?vue&type=template&id=740112d0&scoped=true"
import script from "./RightColumn.vue?vue&type=script&lang=js"
export * from "./RightColumn.vue?vue&type=script&lang=js"
import style0 from "./RightColumn.vue?vue&type=style&index=0&id=740112d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740112d0",
  null
  
)

export default component.exports